import { defineComponent } from "../../../common/runtime/defineComponent.svelte";
import type { Props } from "./TabPanelV1.types";

defineComponent<Props>({
  tag: "oc-tab-panel-v1",
  extendOptions: { useShadow: false },
  props: {
    url: {},
    base64Url: {},
    active: { type: "Boolean" },
    allowedStatusCodes: { type: "Array", attribute: "allowed-status-codes" },
    discardOnInactive: { type: "Boolean", attribute: "discard-on-inactive" },
  },
  component: () => import("./TabPanelV1.svelte"),
  styles: () => import("./TabPanelV1.global.scss?inline"),
});
